module.exports = __webpack_public_path__ + "img/mulazim.ab7d4739.png";